import React, { useEffect, useState } from 'react';

/**
 * POS 직원호출 알림 토스트 — CallNotificationWindow.xaml (C# POS 클라이언트) React 포팅.
 * 상단 노란 헤더(벨 + "호출" + 경과시간) + 하단 다크 바디(테이블 번호 + 호출 사유). 카드 폭 230.
 *
 * 모든 클래스명에 sc- prefix — 다른 컴포넌트와 충돌 방지.
 *
 * Props:
 *   - tableName: string ("1")
 *   - callItems: string[]  호출 사유 라벨 (쉼표로 연결 표시)
 *   - onClose?: () => void  클릭 시 닫힘 (자동 종료 없음)
 */
const StaffCallToast = ({ tableName = '1', callItems = [], onClose }) => {
  const [createdAt] = useState(() => Date.now());
  const [timeText, setTimeText] = useState('방금 전');

  useEffect(() => {
    const tick = () => {
      const elapsed = (Date.now() - createdAt) / 1000;
      if (elapsed < 60) setTimeText('방금 전');
      else if (elapsed < 3600) setTimeText(`${Math.floor(elapsed / 60)}분 전`);
      else setTimeText(`${Math.floor(elapsed / 3600)}시간 전`);
    };
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, [createdAt]);

  const reasons = (callItems || []).filter(Boolean).join(', ');

  return (
    <div className="sc-wrap" onClick={onClose}>
      <div className="sc-enter">
        <div className="sc-shake">
          <div className="sc-card">
            {/* 1. 노란 헤더 */}
            <div className="sc-header">
              <div className="sc-header-left">
                <svg className="sc-bell" viewBox="0 0 24 24" width="21" height="21" fill="none" aria-hidden>
                  <path
                    d="M12 3.5 A1.4 1.4 0 0 1 13.4 4.9 C16 5.5 17.5 7.7 17.5 10.5 V14 L19 16.5 H5 L6.5 14 V10.5 C6.5 7.7 8 5.5 10.6 4.9 A1.4 1.4 0 0 1 12 3.5 Z M9.7 18.4 A2.4 2.4 0 0 0 14.3 18.4"
                    stroke="#191919"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="sc-title">호출</span>
              </div>
              <span className="sc-time">{timeText}</span>
            </div>

            {/* 2. 다크 바디 */}
            <div className="sc-body">
              <div className="sc-table-row">
                <span className="sc-table-num">{tableName || '-'}</span>
                <span className="sc-table-suffix"> 테이블</span>
              </div>
              {reasons && <div className="sc-reasons">{reasons}</div>}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scEnter {
          0%   { opacity: 0; transform: translateY(-14px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes scShake {
          0%    { transform: rotate(0deg); }
          18%   { transform: rotate(-3deg); }
          42%   { transform: rotate(3deg); }
          66%   { transform: rotate(-1.8deg); }
          85%   { transform: rotate(1deg); }
          100%  { transform: rotate(0deg); }
        }

        .sc-wrap {
          pointer-events: auto;
          cursor: pointer;
        }
        .sc-enter {
          animation: scEnter 260ms cubic-bezier(0.2, 0.8, 0.4, 1) both;
        }
        .sc-shake {
          animation: scShake 360ms linear both;
          transform-origin: 50% 50%;
          will-change: transform;
        }
        .sc-card {
          width: 230px;
          background: #232323;
          border-radius: 18px;
          box-shadow: 0 12px 34px rgba(0, 0, 0, 0.35);
          color: #FFFFFF;
          font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
          overflow: hidden;
        }

        /* YELLOW HEADER */
        .sc-header {
          background: #FDCD27;
          padding: 14px 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .sc-header-left {
          display: flex;
          align-items: center;
        }
        .sc-bell {
          display: block;
        }
        .sc-title {
          margin-left: 9px;
          font-size: 17px;
          font-weight: 800;
          color: #191919;
        }
        .sc-time {
          font-size: 13px;
          font-weight: 500;
          color: rgba(25, 25, 25, 0.62);
        }

        /* DARK BODY */
        .sc-body {
          padding: 18px 20px 20px;
        }
        .sc-table-row {
          display: flex;
          align-items: baseline;
        }
        .sc-table-num {
          font-size: 38px;
          font-weight: 800;
          color: #FFFFFF;
          letter-spacing: -0.02em;
          line-height: 1;
        }
        .sc-table-suffix {
          font-size: 16px;
          font-weight: 600;
          color: #9A9A9A;
          margin-left: 4px;
        }
        .sc-reasons {
          margin-top: 14px;
          font-size: 17px;
          font-weight: 700;
          color: #F2F2F2;
          line-height: 24px;
          word-break: keep-all;
        }
      `}</style>
    </div>
  );
};

export default StaffCallToast;
